import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EParamChannelTypeGlobal,
  EParamInventoryTypeGlobal,
  ETimeBucketType,
  EReportingTimeWindow,
  IReportingAdGroupsChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAdGroupsPositionsReportChartFilters,
  TDAAdGroupsReportChartFilters,
  TDOOHAdGroupsReportChartFilters,
  TDOOHAdGroupsScreensReportChartFilters,
  TGenericAdGroupsCategoriesReportChartFilters,
  TGenericAdGroupsKeywordsReportChartFilters,
  TGenericAdGroupsReportChartFilters,
  TPPRetailerId,
  TSPAdGroupsReportChartFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingAdGroupsChartV3({
  retailerId,
  advertiserId,
  inventoryType,
  campaignId,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  channelType,
  enabled = true,
  suspense = true,
}:
  | {
      enabled?: boolean
      suspense?: boolean
    } & (
      | TGenericAdGroupsReportChartFilters
      | TGenericAdGroupsCategoriesReportChartFilters
      | TGenericAdGroupsKeywordsReportChartFilters
      | TSPAdGroupsReportChartFilters
      | TDAAdGroupsReportChartFilters
      | TDAAdGroupsPositionsReportChartFilters
      | TDOOHAdGroupsReportChartFilters
      | TDOOHAdGroupsScreensReportChartFilters
    ) &
      TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingAdGroupsChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingAdGroupsChart_${inventoryType}_${retailerId}_${advertiserId}`

  return useQuery(
    [
      queryKeyName,
      { start: startDate, end: endDate, campaignId, inventoryType },
    ],
    () => {
      return coreAPIV3.retailerReporting().getRetailerAdGroupsReportChartV3(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        inventoryType as EParamInventoryTypeGlobal,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status,
        channelType as EParamChannelTypeGlobal | undefined
      )
    },
    { suspense, enabled }
  )
}
